/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-23 13:28:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag/index.tsx
 */
import React from 'react';
import { EShoppingCartStatus } from '@/src/types/common/order';
import css from './css.module.less';
import { getI18nFromGeneral } from '@/src/tools/tools';

const StatusTag = ({ status }) => {
  const tagColor = {
    [EShoppingCartStatus.Active]: {
      color: '#52C41A',
      backgroundColor: '#F6FFED',
      label: getI18nFromGeneral('general.status.active'),
    },
    [EShoppingCartStatus.Draft]: {
      color: '#FAAD14',
      backgroundColor: '#FFFBE6',
      label: getI18nFromGeneral('general.status.draft'),
    },

    [EShoppingCartStatus.Locked]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.locked'),
    },
  };
  const t = tagColor[status] || {};
  return (
    <div
      className={css.statusTag}
      style={{
        ...t,
        border: `1px solid ${t.color}`,
      }}>
      {t.label}
    </div>
  );
};

export default StatusTag;
